export const API_KEY = 'A01rEE8JEQjoceerZ1kuLlAT7m2fKz2y'

export const API_URL = 'https://api.giphy.com/v1'